// @core/api/endpoints/tenant/cancel_tenant_migration.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CancelTenantMigrationRequest,
  TenantMigrationResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Cancel tenant migration
 * Cancels a pending or in-progress migration. If migration is in progress, triggers rollback to restore the tenant on the source platform.
 */
export async function CancelTenantMigration(
  tenant_id: string,
  migration_id: string,
  data: CancelTenantMigrationRequest,
  options?: RequestOptions
): Promise<TenantMigrationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/migration/:migration_id/cancel`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  requestPath = requestPath.replace(':migration_id', encodeURIComponent(migration_id));
  const requestOptions = options;
  return client.post<TenantMigrationResponse>(requestPath, data, requestOptions);
}
